module.exports = __webpack_public_path__ + "static/media/border-style.f8e2e2de.svg";